import CustomerTypeBar from './CustomerTypeBar';

export default CustomerTypeBar;


// WEBPACK FOOTER //
// ./src/components/CustomerTypeBar/index.jsx